import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Maintenance',
      type: 'metric',
      content: {
        '{}': {
          value: {
            '{}': {
              emphasis: 'Coming soon',
            },
          },
        },
      },
    },
  },
}
